$(document).ready(function(){
	if($('.category-slider').length) {
		$('.category-slider').slick({
			centerMode:true,
			centerPadding:'104px',
			slidesToShow:3,
			arrows:false,
			dots:false,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 1
					}
				},
				{
					breakpoint: 769,
					settings: {
						centerPadding:'60px',
						slidesToShow: 1
					}
				}
			]
		});
	}
});

$(document).on('click', '.faq-item > a', function(){
	$(this).closest('.faq-item').toggleClass('active');
	$(this).closest('.faq-item').find('.rte').slideToggle();
});